import { useState } from "react";
import "./socketMaterial.scss";
import MuiRadio from "../radio/MuiRadio";
import MuiCheckbox from "../checkbox/MuiCheckbox";
import Revofit from "../Revofit";
import { FileUploadIcon } from "../../icons/svg";
import { Button } from "@mui/material";

const SocketMaterial = ({
  setActiveInnerStep,
  options,
  insertMaterial,
  onChange,
  checkChange,
  checkBoxes,
  value,
  revoFitEnabled,
  labelOnChange,
  revoChange,
  SocketMaterialDefaultValue,
  insertMaterialDefaultValue,
  error,
  required,
  revoOptionDefaultValue,
  fileChange,
  removeFile,
  addExistingFile,
  fileName,
  additionalWindowValue,
  additionalWindowRequired,
  additionalWindowChange,
}) => {
  const fromCADFileId = 111;
  const polypropyleneCopolymerSelectedId = 109;
  const [showRevo, setShowRevo] = useState(SocketMaterialDefaultValue);

  const SocketOption = options.map((option) => ({
    displayName: option.displayName,
    id: option.id,
    partNumbers: option.partNumbers,
  }));

  const handleRevoDisplay = (e) => {
    setActiveInnerStep(3);
    if (parseInt(e.target.value) !== fromCADFileId) {
      if (removeFile !== undefined) {
        removeFile();
      }
    } else {
      if (addExistingFile !== undefined) {
        addExistingFile();
      }
    }

    setShowRevo(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  const shapeCreationContent = [
    {
      name: "Polypropylene Copolymer",
      content: "",
    },

    {
      name: "Carbon from Cast",
      content: "",
    },

    {
      name: "Carbon from CAD",
      content: (
        <div className="fileUpload">
          <Button
            component="label"
            variant="contained"
            startIcon={<FileUploadIcon />}
          >
            Upload File
            <input
              type="file"
              style={{ display: "none" }}
              onChange={fileChange}
            />
          </Button>
          <span>{fileName}</span>
        </div>
      ),
    },
  ];

  const shapeCreationOptions = SocketOption.map((option) => ({
    displayName: option.displayName,
    id: option.id,
    content: shapeCreationContent.find(
      (cont) => cont.name === option.displayName
    )?.content,
  }));

  return (
    <div className="socketMaterial">
      <div className="fieldBorder">
        <MuiRadio
          options={shapeCreationOptions}
          required={required}
          label="Socket Material"
          defaultValue={SocketMaterialDefaultValue}
          onChange={handleRevoDisplay}
          error={error}
          content="sfkfjdkfkjd"
        />
      </div>

      <div className="fieldBorder">
        <MuiCheckbox
          checkboxes={insertMaterial}
          boxLabel="Insert Material"
          onChange={checkChange}
          defaultValue={insertMaterialDefaultValue}
        />
      </div>
      {parseInt(showRevo) !== polypropyleneCopolymerSelectedId && (
        <div className="fieldBorder">
          <Revofit
            setActiveInnerStep={setActiveInnerStep}
            checkBoxesOption={checkBoxes}
            value={value}
            labelOnChange={labelOnChange}
            revoChange={revoChange}
            revoFitDefaultValue={revoFitEnabled}
            revoOptionDefaultValue={revoOptionDefaultValue}
            additionalWindowValue={additionalWindowValue}
            additionalWindowRequired={additionalWindowRequired}
            additionalWindowChange={additionalWindowChange}
          />
        </div>
      )}
    </div>
  );
};

export default SocketMaterial;
